import { useFormikContext } from 'formik';
import { PluginsFormType } from './PluginsFormContainer';
import {
  usePluginConnectionByID,
  usePluginConnectionStatusTypes,
} from 'hooks/SparkBuilder/pluginFunction';
import { SparkFormButton } from 'sharedComponents/SparkForm';

type PluginFormButtonProps = {
  pluginAuthenticationID: string | undefined;
  isMutating: boolean;
};
function PluginFormButton({
  pluginAuthenticationID,
  isMutating,
}: PluginFormButtonProps) {
  const { values: pluginFormValue } = useFormikContext<PluginsFormType>();
  const {
    pluginConnectionStatusTypeIDMap,
    isLoading: isPluginConnectionStatusLoading,
  } = usePluginConnectionStatusTypes();

  const { pluginConnection, isLoading: isPluginConnectionLoading } =
    usePluginConnectionByID(pluginFormValue.pluginConnectionID);
  const pluginConnectionStatusType =
    pluginConnectionStatusTypeIDMap?.[
      pluginConnection?.attributes.pluginConnectionStatusTypeID + ''
    ];
  const statusType = pluginConnectionStatusType?.attributes.name;

  const inActive = statusType === 'Unauthorized';

  const isDisabled =
    (Boolean(pluginAuthenticationID) && !pluginFormValue.pluginConnectionID) ||
    inActive ||
    isPluginConnectionLoading ||
    isPluginConnectionStatusLoading ||
    isMutating;

  return (
    <SparkFormButton
      sx={{
        alignSelf: 'flex-end',
        paddingY: 1.5,
        paddingX: 3,
      }}
      disabled={isDisabled}
    >
      Continue
    </SparkFormButton>
  );
}
export default PluginFormButton;
